const ImageItem = ({ video_id, title, image_src, alt, onClick }) => {
    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/uri-list', e.target.src);
        e.dataTransfer.setData('text/plain', e.target.src);
        e.dataTransfer.setData('text/id', e.target.id);
        e.dataTransfer.setData('text/title', e.target.title);
        e.dataTransfer.setData('text/alt', e.target.alt);
    };

    return (
        <img
            id={video_id}
            name={video_id}
            className='flex w-full mb-1 rounded-lg aspect-video object-cover'
            src={image_src}
            title={title}
            alt={alt}
            onClick={onClick}
            draggable="true"
            onDragStart={handleDragStart}
        />
    );
};

export default ImageItem;

